import React from 'react'
import classnames from 'classnames'
import { object, bool } from 'prop-types'
import { FilingStatus } from '../services/FilingStatus'
import VerticalNameChildren from '../../../components/library/layout/VerticalNameChildren'
import HrbTranslate from '../../../components/language/HrbTranslate'
import EmdashText from '../../../components/library/common/EmdashText'
import CollapsibleCardContent from '../../../components/library/stacking-collapsible-cards/CollapsibleCardContent'
import Skeleton from '../../../components/library/loaders/Skeleton'

const FilingStatusSummary = props => {
    const { CRAStatus, RQStatus, T1135Status, collapsed, loading, boldText} = props

    const renderStatus = r => {
        let statusKey = `ReturnInfo.FilingStatus.${r.dashboardStatus === 'PAPERFILED' ? FilingStatus.MAILEDIN : r.status || 'IN_PROGRESS'}`
        let error = [FilingStatus.REJECTED, FilingStatus.REJECT, FilingStatus.ERROR].includes(r.status)
        return <HrbTranslate text={statusKey} className={error ? 'error-text' : 'status-text'} />
    }

    const p1FontWeight = boldText ? 'p1 analyst-font-bold' : 'p1 medium-weight'

    return (
        <CollapsibleCardContent className={classnames('py-3', { 'bottom-border': !collapsed })}>
            <div className='column is-4 ml-0 pl-0'>
                <VerticalNameChildren textKey='ReturnInfo.Labels.CRA'>
                    {CRAStatus ?
                        <p className={p1FontWeight}>{renderStatus(CRAStatus)}</p> :
                        <span className='p1 medium-weight'>{loading ? <Skeleton /> : <EmdashText />}</span>}
                </VerticalNameChildren>
            </div>
            <div className='column is-4'>
                {!!RQStatus && !loading &&
                    <VerticalNameChildren textKey='ReturnInfo.Labels.RQ'>
                        {RQStatus ?
                        <p className={p1FontWeight}>{renderStatus(RQStatus)}</p> :
                            <p className='p1 medium-weight'><EmdashText /></p>}
                    </VerticalNameChildren>
                }
            </div>
            <div className='column is-4 mr-0 pr-0'>
                {!!T1135Status && !loading &&
                    <VerticalNameChildren textKey='ReturnInfo.Labels.T1135'>
                        {T1135Status ?
                        <p className={p1FontWeight}>{renderStatus(T1135Status)}</p> :
                            <p className='p1 medium-weight'><EmdashText /></p>}
                    </VerticalNameChildren>
                }
            </div>
        </CollapsibleCardContent>)
}

FilingStatusSummary.propTypes = {
    CRAStatus: object,
    RQStatus: object,
    T1135Status: object,
    loading: bool,
    collapsed: bool
}

export default FilingStatusSummary